/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import { useServiceUrl } from 'domain/shared/service';

const ServiceBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useServiceUrl();
  const serviceListLink = getListUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Service" link={serviceListLink} />
      {children}
    </Breadcrumbs>
  );
};

export default ServiceBreadcrumbs;
